/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-trigger.js
 *
 * 指定クラスの位置までスクロールして,実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import Flip from "gsap/Flip";
gsap.registerPlugin(Flip);

const setGsapFlip = () => {
	const slider = document.querySelector(".slider-concept8 .slider-wrapper");
	if (!slider) {
		return; // .slider-concept8クラスが存在しない場合は処理を中断
	}
	const slides = gsap.utils.toArray(".slide");
	const offset = 30;
	// スライドを移動する関数
	function moveCard() {
		const lastslide = slider.querySelector(".slide:last-child");
		if (slider && lastslide) {
			lastslide.style.display = "none"; // 最後のスライドを非表示にする
			const newslide = document.createElement("div");
			newslide.className = lastslide.className; // 同じクラス名を設定する
			newslide.innerHTML = lastslide.innerHTML; // 非表示にした.slideの中身すべてコピーする
			slider.insertBefore(newslide, slider.firstChild); // 新しいスライドをスライダーの最初に挿入する
		}
	}

	// スライドを進める関数
	function advanceSlide() {
		let state = Flip.getState(".slide");
		moveCard();
		Flip.from(state, {
			targets: ".slide",
			ease: "sine.inOut",
			absolute: true,
			onEnter: (elements) => {
				return gsap.from(elements, {
					opacity: 0,
					ease: "sine.out",
				});
			},
			onLeave: (element) => {
				return gsap.to(element, {
					clipPath: "inset(0 100% 0 0)",
					transformOrigin: "bottom left",
					duration: 0.9,
					ease: "sine.out",
					onComplete() {
						// console.log("logging", element[0]);
						slider.removeChild(element[0]);
					},
				});
			},
		});
	}

	// 次のスライドボタンのクリックイベント
	document.querySelector(".slider-arrow-next").addEventListener("click", (e) => {
		advanceSlide();
	});

	// オートプレイの設定
	let autoplay = setInterval(advanceSlide, 4000); // 4秒ごとにスライドを進める

	// スライダーにマウスオーバーでオートプレイを一時停止
	slider.addEventListener("mouseover", () => {
		clearInterval(autoplay);
	});

	// スライダーからマウスが離れたらオートプレイを再開
	slider.addEventListener("mouseout", () => {
		autoplay = setInterval(advanceSlide, 4000);
	});
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setGsapFlip };
